<section class="page-hero contact-hero-pro">
    <div class="contact-hero-bg"></div>

    <div class="container">
        <div class="contact-hero-content">
            <span class="eyebrow"><i></i> Contact & RFQ</span>

            <h1>Send your requirement to IOSC.</h1>

            <p>
                Share product lists, technical requirements, delivery details or certificate questions
                directly with the IOSC team.
            </p>
        </div>
    </div>
</section>

<section class="section contact-section-pro" id="quote">
    <div class="container contact-rfq-layout">

        <aside class="contact-offices-panel reveal">
            <span class="section-kicker">Regional Offices</span>

            <h2>Contact IOSC across key operating regions.</h2>

            <p class="contact-office-intro">
                IOSC offices support customers with industrial supply, RFQ coordination,
                testing documentation and regional project requirements.
            </p>

            <div *ngIf="loadingOffices" style="padding:14px 0">
                Loading offices...
            </div>

            <div class="contact-office-list">
                <article class="contact-office-detail-card reveal"
                         [class.selected]="isSelectedOffice(o.country)"
                         *ngFor="let o of officeLocations">
                    <h3>{{ o.country }}</h3>

                    <small>{{ o.city }}</small>

                    <p>{{ o.address }}</p>

                    <div class="office-contact-lines">
                        <b>{{ o.phoneLabel }}</b>
                        <span>{{ o.phone }}</span>
                    </div>

                    <div class="office-contact-lines" *ngIf="o.secondPhone">
                        <b>{{ o.secondPhoneLabel }}</b>
                        <span>{{ o.secondPhone }}</span>
                    </div>

                    <div class="office-contact-lines">
                        <b>E-mail</b>
                        <span>{{ o.email }}</span>
                    </div>
                </article>
            </div>
        </aside>

        <main class="quote-panel contact-quote-panel-pro reveal">
            <div class="contact-highlight">
                <b>Fast response</b>
                <span>
                    Send requirements, technical details or certificate questions directly to the IOSC team.
                </span>
            </div>

            <h2 style="font-size:34px;margin-top:0">Request a Quote</h2>

            <p style="color:var(--muted)">
                Submit your requirement and the IOSC team will review it.
            </p>

            <form class="form-grid" #quoteForm="ngForm" (ngSubmit)="submit()">

                <div class="field">
                    <label>Full Name</label>
                    <input required
                           name="fullName"
                           [(ngModel)]="model.fullName"
                           placeholder="Your name">
                </div>

                <div class="field">
                    <label>Company</label>
                    <input name="company"
                           [(ngModel)]="model.company"
                           placeholder="Company name">
                </div>

                <div class="field">
                    <label>Email</label>
                    <input required
                           type="email"
                           name="email"
                           [(ngModel)]="model.email"
                           placeholder="email@company.com">
                </div>

                <div class="field">
                    <label>Phone</label>
                    <input name="phone"
                           [(ngModel)]="model.phone"
                           placeholder="+994...">
                </div>

                <div class="field">
                    <label>Service / Category</label>
                    <select name="serviceCategory"
                            [(ngModel)]="model.serviceCategory">
                        <option>Industrial Supply</option>
                        <option>Rental</option>
                        <option>Manufacturing</option>
                        <option>Testing</option>
                        <option>Warehousing</option>
                        <option>Liquid Controls</option>
                    </select>
                </div>

                <div class="field">
                    <label>Priority</label>
                    <select name="priority"
                            [(ngModel)]="model.priority">
                        <option>Normal</option>
                        <option>Urgent</option>
                        <option>Project tender</option>
                    </select>
                </div>

                <div class="field full">
                    <label>Requirement</label>
                    <textarea required
                              name="message"
                              [(ngModel)]="model.message"
                              placeholder="Write product list, quantities, specs, delivery location..."></textarea>
                </div>

                <div class="field full" *ngIf="successMessage">
                    <div class="alert success">
                        {{ successMessage }}
                    </div>
                </div>

                <div class="field full" *ngIf="errorMessage">
                    <div class="alert error">
                        {{ errorMessage }}
                    </div>
                </div>

                <div class="field full">
                    <button class="btn btn-primary"
                            type="submit"
                            [disabled]="sending || quoteForm.invalid">
                        {{ sending ? 'Submitting...' : 'Submit RFQ' }}
                    </button>
                </div>

            </form>
        </main>

    </div>
</section>

<section class="section contact-map-section">
    <div class="container">

        <div class="section-head reveal">
            <div>
                <span class="section-kicker">Office Map</span>
                <h2>Find IOSC offices on the regional map.</h2>
            </div>

            <p>
                Map points show IOSC office locations and contact details for Azerbaijan,
                Georgia, Kazakhstan and UK.
            </p>
        </div>

        <div class="contact-map-card reveal">
            <div id="ioscContactMap" class="iosc-contact-map"></div>
        </div>

    </div>
</section>

